// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer rdg.MeasuringCell {.mlln6zg7-0-0-beta-40 {
    contain: strict;
    grid-row: 1;
    visibility: hidden
}
  }


@layer rdg.Cell {.cj343x07-0-0-beta-40 {
    /* max-content does not work with size containment
     * dynamically switching between different containment styles incurs a heavy relayout penalty
     * Chromium bug: at odd zoom levels or subpixel positioning,
     * layout/paint/style containment can make cell borders disappear
     *   https://bugs.chromium.org/p/chromium/issues/detail?id=1326946
     */
    position: relative; /* needed for absolute positioning to work */
    padding-block: 0;
    padding-inline: 8px;
    border-inline-end: 1px solid var(--rdg-border-color) !important;
    border-block-end: 1px solid var(--rdg-border-color) !important;
    grid-row-start: var(--rdg-grid-row-start);
    background-color: inherit;

    white-space: nowrap;
    overflow: clip;
    text-overflow: ellipsis;
    outline: none;
    font-size: medium;
    font-weight: 400;
    
}

    .cj343x07-0-0-beta-40[aria-selected='true'] {
      outline: 2px solid var(--rdg-selection-color);
      outline-offset: -2px;
    }

.csofj7r7-0-0-beta-40 {
    position: sticky;
    /* Should have a higher value than 0 to show up above unfrozen cells */
    z-index: 1
}

.ch2wcw87-0-0-beta-40 {
    box-shadow: calc(2px * var(--rdg-sign)) 0 5px -2px rgba(136, 136, 136, 0.3)
}
  }


@layer rdg.CheckboxLabel {.c1bn88vv7-0-0-beta-40 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    inset: 0;
    margin-inline-end: 1px /* align checkbox in row group cell */
}
  }

@layer rdg.CheckboxInput {

.c1qt073l7-0-0-beta-40 {
    all: unset
}
  }

@layer rdg.CheckboxIcon {

.cf71kmq7-0-0-beta-40 {
    content: '';
    inline-size: 20px;
    block-size: 20px;
    border: 2px solid var(--rdg-border-color);
    background-color: var(--rdg-background-color)
}

    .c1qt073l7-0-0-beta-40:checked + .cf71kmq7-0-0-beta-40 {
      background-color: var(--rdg-checkbox-color);
      outline: 4px solid var(--rdg-background-color);
      outline-offset: -6px;
    }

    .c1qt073l7-0-0-beta-40:focus + .cf71kmq7-0-0-beta-40 {
      border-color: var(--rdg-checkbox-focus-color);
    }
  }

@layer rdg.CheckboxLabel {

.c1lwve4p7-0-0-beta-40 {
    cursor: default
}

    .c1lwve4p7-0-0-beta-40 .cf71kmq7-0-0-beta-40 {
      border-color: var(--rdg-checkbox-disabled-border-color);
      background-color: var(--rdg-checkbox-disabled-background-color);
    }
  }


@layer rdg.GroupCellContent {.g1s9ylgp7-0-0-beta-40 {
    outline: none
}
  }

@layer rdg.GroupCellCaret {

.cz54e4y7-0-0-beta-40 {
    margin-inline-start: 4px;
    stroke: currentColor;
    stroke-width: 1.5px;
    fill: transparent;
    vertical-align: middle
}

    .cz54e4y7-0-0-beta-40 > path {
      transition: d 0.1s;
    }
  }


@layer rdg.DragHandle {.c1w9bbhr7-0-0-beta-40 {
    --rdg-drag-handle-size: 8px;
    z-index: 0;
    cursor: move;
    inline-size: var(--rdg-drag-handle-size);
    block-size: var(--rdg-drag-handle-size);
    background-color: var(--rdg-selection-color);
    place-self: end
}

    .c1w9bbhr7-0-0-beta-40:hover {
      --rdg-drag-handle-size: 16px;
      border: 2px solid var(--rdg-selection-color);
      background-color: var(--rdg-background-color);
    }

.c1creorc7-0-0-beta-40 {
    z-index: 1;
    position: sticky
}
  }


@layer rdg.EditCell {.cis5rrm7-0-0-beta-40 {
    padding: 0
}
  }


@layer rdg.SortableHeaderCell {.h44jtk67-0-0-beta-40 {
    display: flex;
    justify-content: center;
    align-items: center;
}
  }

@layer rdg.SortableHeaderCellName {

.hcgkhxz7-0-0-beta-40 {
    flex-grow: 1;
    overflow: clip;
    text-overflow: ellipsis;
    font-weight: 700;
    font-size: large;
    
}
  }


@layer rdg.HeaderCell {.c6l2wv17-0-0-beta-40 {
    cursor: pointer
}

.c1kqdw7y7-0-0-beta-40 {
    touch-action: none
}

.r1y6ywlx7-0-0-beta-40 {
    cursor: col-resize;
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    inset-block-end: 0;
    inline-size: 10px
}
  }

.c1bezg5o7-0-0-beta-40 {
  opacity: 0.5;
}

.c1vc96037-0-0-beta-40 {
  background-color: var(--rdg-header-draggable-background-color);
}


@layer rdg.Row {.r1upfr807-0-0-beta-40 {
    display: contents;
    line-height: var(--rdg-row-height);

    background-color: var(--rdg-background-color)
}

    .r1upfr807-0-0-beta-40:hover {
      background-color: #8cb3fb //var(--rdg-row-hover-background-color);
    }

    .r1upfr807-0-0-beta-40[aria-selected='true'] {
      background-color: var(--rdg-row-selected-background-color);
    }

      .r1upfr807-0-0-beta-40[aria-selected='true']:hover {
        background-color: #8cb3fb//var(--rdg-row-selected-hover-background-color);
      }
  }

@layer rdg.FocusSink {

.r190mhd37-0-0-beta-40 {
    outline: 2px solid var(--rdg-selection-color);
    outline-offset: -2px
}
    .r139qu9m7-0-0-beta-40::before {
      content: '';
      display: inline-block;
      height: 100%;
      position: sticky;
      inset-inline-start: 0;
      border-inline-start: 2px solid var(--rdg-selection-color);
    }
  }


@layer rdg.HeaderRow {.h10tskcx7-0-0-beta-40 {
    display: contents;
    line-height: var(--rdg-header-row-height);
    background-color: #264390;
    font-weight: bold;
    color: white;
}

    .h10tskcx7-0-0-beta-40 > .cj343x07-0-0-beta-40 {
      /* Should have a higher value than 1 to show up above regular cells and the focus sink */
      z-index: 2;
      position: sticky;
      font-size: large;
      font-weight: 700;
    }

    .h10tskcx7-0-0-beta-40 > .csofj7r7-0-0-beta-40 {
      z-index: 3;
    }
  }


@layer rdg.Cell {.c6ra8a37-0-0-beta-40 {
    background-color: #ccccff
}

.cq910m07-0-0-beta-40 {
    background-color: #ccccff
}

    .cq910m07-0-0-beta-40.c6ra8a37-0-0-beta-40 {
      background-color: #9999ff;
    }
  }


@layer rdg.SortIcon {.a3ejtar7-0-0-beta-40 {
    fill: currentColor;
    height: 16px;
    width: 12px;
}

    .a3ejtar7-0-0-beta-40 > path {
      transition: d 0.1s;
    }
  }


@layer rdg {
    @layer Defaults,
      FocusSink,
      CheckboxInput,
      CheckboxIcon,
      CheckboxLabel,
      Cell,
      HeaderCell,
      SummaryCell,
      EditCell,
      Row,
      HeaderRow,
      SummaryRow,
      GroupedRow,
      Root;

    @layer Defaults {
      .rnvodz57-0-0-beta-40 *,
      .rnvodz57-0-0-beta-40 *::before,
      .rnvodz57-0-0-beta-40 *::after {
        box-sizing: inherit;
      }
    }

    @layer Root {.rnvodz57-0-0-beta-40 {
      --rdg-color: #000;   --rdg-border-color: #ddd;   --rdg-summary-border-color: #aaa;   --rdg-background-color: hsl(0deg 0% 100%);   --rdg-header-background-color: hsl(0deg 0% 97.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 90.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 96%);   --rdg-row-selected-background-color: hsl(207deg 76% 92%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 88%);   --rdg-checkbox-color: hsl(207deg 100% 29%);   --rdg-checkbox-focus-color: hsl(207deg 100% 69%);   --rdg-checkbox-disabled-border-color: #ccc;   --rdg-checkbox-disabled-background-color: #ddd;
      --rdg-selection-color: #66afe9;
      --rdg-font-size: 14px;

      display: grid;

      color-scheme: var(--rdg-color-scheme, light dark);

      /* https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context */
      /* We set a stacking context so internal elements don't render on top of external elements. */
      /* size containment is not used as it could break "width: min-content" for example, and the grid would infinitely resize on Chromium browsers */
      contain: content;
      content-visibility: auto;
      block-size: 80vh;
      border: 1px solid var(--rdg-border-color) !important;
      box-sizing: border-box;
      overflow: auto;
      background-color: var(--rdg-background-color);
      color: var(--rdg-color);
      font-size: var(--rdg-font-size)

      /* needed on Firefox to fix scrollbars */
}
      .rnvodz57-0-0-beta-40::before {
        content: '';
        grid-column: 1/-1;
        grid-row: 1/-1;
      }

      .rnvodz57-0-0-beta-40.rdg-dark {
        --rdg-color-scheme: dark;
        --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 17.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;
      }

      .rnvodz57-0-0-beta-40.rdg-light {
        --rdg-color-scheme: light;
      }

      @media (prefers-color-scheme: dark) {
        .rnvodz57-0-0-beta-40:not(.rdg-light) {
          --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 17.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;
        }
      }
    }
  }

@layer rdg.Root {

.vlqv91k7-0-0-beta-40 {
    -webkit-user-select: none;
            user-select: none
}

    .vlqv91k7-0-0-beta-40 .r1upfr807-0-0-beta-40 {
      cursor: move;
    }
  }

@layer rdg.FocusSink {

.f1lsfrzw7-0-0-beta-40 {
    grid-column: 1/-1;
    pointer-events: none;
    /* Should have a higher value than 1 to show up above regular frozen cells */
    z-index: 1
}

.f1cte0lg7-0-0-beta-40 {
    /* Should have a higher value than 3 to show up above header and summary rows */
    z-index: 3
}
  }


@layer rdg.SummaryCell {.s8wc6fl7-0-0-beta-40 {
    inset-block-start: var(--rdg-summary-row-top);
    inset-block-end: var(--rdg-summary-row-bottom)
}
  }


@layer rdg.SummaryRow {.skuhp557-0-0-beta-40 {
    line-height: var(--rdg-summary-row-height)
}

    .skuhp557-0-0-beta-40 > .cj343x07-0-0-beta-40 {
      position: sticky;
    }
    .tf8l5ub7-0-0-beta-40 > .cj343x07-0-0-beta-40 {
      z-index: 2;
    }

    .tf8l5ub7-0-0-beta-40 > .csofj7r7-0-0-beta-40 {
      z-index: 3;
    }
    .tb9ughf7-0-0-beta-40 > .cj343x07-0-0-beta-40 {
      border-block-end: 2px solid var(--rdg-summary-border-color);
    }
    .b1yssfnt7-0-0-beta-40 > .cj343x07-0-0-beta-40 {
      border-block-start: 2px solid var(--rdg-summary-border-color);
    }
  }


@layer rdg.GroupedRow {
    .g1yxluv37-0-0-beta-40:not([aria-selected='true']) {
      background-color: var(--rdg-header-background-color);
    }

    .g1yxluv37-0-0-beta-40 > .cj343x07-0-0-beta-40:not(:last-child):not(.ch2wcw87-0-0-beta-40) {
      border-inline-end: none;
    }
  }


@layer rdg.TextEditor {.t7vyx3i7-0-0-beta-40 {
    appearance: none;

    box-sizing: border-box;
    inline-size: 100%;
    block-size: 100%;
    padding-block: 0;
    padding-inline: 6px;
    border: 2px solid #ccc;
    vertical-align: top;
    color: var(--rdg-color);
    background-color: var(--rdg-background-color);

    font-family: inherit;
    font-size: var(--rdg-font-size)
}

    .t7vyx3i7-0-0-beta-40:focus {
      border-color: var(--rdg-selection-color);
      outline: none;
    }

    .t7vyx3i7-0-0-beta-40::placeholder {
      color: #999;
      opacity: 1;
    }
  }

`, "",{"version":3,"sources":["webpack://./src/components/Table/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;IACtB,eAAe;IACf,WAAW;IACX;AACJ;EACE;;;AAGF,iBAAiB;IACb;;;;;MAKE;IACF,kBAAkB,EAAE,4CAA4C;IAChE,gBAAgB;IAChB,mBAAmB;IACnB,+DAA+D;IAC/D,8DAA8D;IAC9D,yCAAyC;IACzC,yBAAyB;;IAEzB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;;AAEpB;;IAEI;MACE,6CAA6C;MAC7C,oBAAoB;IACtB;;AAKJ;IACI,gBAAgB;IAChB,sEAAsE;IACtE;AACJ;;AAKA;IACI;AACJ;EAfE;;;AAmBF,0BAA0B;IACtB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,qBAAqB,EAAE,qCAAqC;AAChE;EACE;;AAEF;;AAEA;IACI;AACJ;EACE;;AAEF;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC;AACJ;;IAEI;MACE,2CAA2C;MAC3C,8CAA8C;MAC9C,oBAAoB;IACtB;;IAEA;MACE,6CAA6C;IAC/C;EACF;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,uDAAuD;MACvD,+DAA+D;IACjE;EACF;;;AAGF,6BAA6B;IACzB;AACJ;EACE;;AAEF;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;IAEI;MACE,kBAAkB;IACpB;EACF;;;AAGF,uBAAuB;IACnB,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,uCAAuC;IACvC,4CAA4C;IAC5C;AACJ;;IAEI;MACE,4BAA4B;MAC5B,4CAA4C;MAC5C,6CAA6C;IAC/C;;AAKJ;IACI,UAAU;IACV;AACJ;EAPE;;;AAWF,qBAAqB;IACjB;AACJ;EACE;;;AAGF,+BAA+B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;EACE;;AAEF;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;;AAEpB;EACE;;;AAGF,uBAAuB;IACnB;AACJ;;AAKA;IACI;AACJ;;AAKA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;EAlBE;;AAqBF;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;AAChE;;;AAGA,gBAAgB;IACZ,iBAAiB;IACjB,kCAAkC;;IAElC;AACJ;;IAEI;MACE,iEAAiE;IACnE;;IAEA;MACE,0DAA0D;IAC5D;;MAEE;QACE,yEAAyE;MAC3E;EACJ;;AAEF;;AAEA;IACI,6CAA6C;IAC7C;AACJ;IAII;MACE,WAAW;MACX,qBAAqB;MACrB,YAAY;MACZ,gBAAgB;MAChB,qBAAqB;MACrB,yDAAyD;IAC3D;EAVF;;;AAcF,sBAAsB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;IAEI;MACE,wFAAwF;MACxF,UAAU;MACV,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,UAAU;IACZ;EACF;;;AAGF,iBAAiB;IACb;AACJ;;AAKA;IACI;AACJ;;IAEI;MACE,yBAAyB;IAC3B;EAVF;;;AAcF,qBAAqB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;IAEI;MACE,kBAAkB;IACpB;EACF;;;AAGF;IACI;;;;;;;;;;;;;UAaM;;IAEN;MACE;;;QAGE,mBAAmB;MACrB;IACF;;IAEA,aAAa;MACX,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,yCAAyC,IAAI,iDAAiD,IAAI,2DAA2D,IAAI,kDAAkD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;MACxmB,8BAA8B;MAC9B,qBAAqB;;MAErB,aAAa;;MAEb,iDAAiD;;MAEjD,gHAAgH;MAChH,6FAA6F;MAC7F,+IAA+I;MAC/I,gBAAgB;MAChB,wBAAwB;MACxB,gBAAgB;MAChB,oDAAoD;MACpD,sBAAsB;MACtB,cAAc;MACd,6CAA6C;MAC7C,uBAAuB;MACvB,8BAA8B;;MAE9B,wCAAwC;AAC9C;MACM;QACE,WAAW;QACX,iBAAiB;QACjB,cAAc;MAChB;;MAEA;QACE,wBAAwB;QACxB,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,wCAAwC,IAAI,iDAAiD,IAAI,2DAA2D,IAAI,iDAAiD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;MACxmB;;MAEA;QACE,yBAAyB;MAC3B;;MAEA;QACE;UACE,iBAAiB,IAAI,wBAAwB,IAAI,gCAAgC,IAAI,wCAAwC,IAAI,iDAAiD,IAAI,2DAA2D,IAAI,iDAAiD,IAAI,wDAAwD,IAAI,8DAA8D,IAAI,0CAA0C,IAAI,gDAAgD,IAAI,0CAA0C,IAAI,8CAA8C;QACxmB;MACF;IACF;EACF;;AAEF;;AAEA;IACI,yBAAgB;YAAhB;AACJ;;IAEI;MACE,YAAY;IACd;EACF;;AAEF;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,4EAA4E;IAC5E;AACJ;;AAKA;IACI,+EAA+E;IAC/E;AACJ;EAPE;;;AAWF,wBAAwB;IACpB,6CAA6C;IAC7C;AACJ;EACE;;;AAGF,uBAAuB;IACnB;AACJ;;IAEI;MACE,gBAAgB;IAClB;IAIA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;IAIA;MACE,2DAA2D;IAC7D;IAIA;MACE,6DAA6D;IAC/D;EArBF;;;AAyBF;IACI;MACE,oDAAoD;IACtD;;IAEA;MACE,uBAAuB;IACzB;EACF;;;AAGF,uBAAuB;IACnB,gBAAgB;;IAEhB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;;IAE7C,oBAAoB;IACpB;AACJ;;IAEI;MACE,wCAAwC;MACxC,aAAa;IACf;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;EACF","sourcesContent":["@layer rdg.MeasuringCell {.mlln6zg7-0-0-beta-40 {\n    contain: strict;\n    grid-row: 1;\n    visibility: hidden\n}\n  }\n\n\n@layer rdg.Cell {.cj343x07-0-0-beta-40 {\n    /* max-content does not work with size containment\n     * dynamically switching between different containment styles incurs a heavy relayout penalty\n     * Chromium bug: at odd zoom levels or subpixel positioning,\n     * layout/paint/style containment can make cell borders disappear\n     *   https://bugs.chromium.org/p/chromium/issues/detail?id=1326946\n     */\n    position: relative; /* needed for absolute positioning to work */\n    padding-block: 0;\n    padding-inline: 8px;\n    border-inline-end: 1px solid var(--rdg-border-color) !important;\n    border-block-end: 1px solid var(--rdg-border-color) !important;\n    grid-row-start: var(--rdg-grid-row-start);\n    background-color: inherit;\n\n    white-space: nowrap;\n    overflow: clip;\n    text-overflow: ellipsis;\n    outline: none;\n    font-size: medium;\n    font-weight: 400;\n    \n}\n\n    .cj343x07-0-0-beta-40[aria-selected='true'] {\n      outline: 2px solid var(--rdg-selection-color);\n      outline-offset: -2px;\n    }\n  }\n\n@layer rdg.Cell {\n\n.csofj7r7-0-0-beta-40 {\n    position: sticky;\n    /* Should have a higher value than 0 to show up above unfrozen cells */\n    z-index: 1\n}\n  }\n\n@layer rdg.Cell {\n\n.ch2wcw87-0-0-beta-40 {\n    box-shadow: calc(2px * var(--rdg-sign)) 0 5px -2px rgba(136, 136, 136, 0.3)\n}\n  }\n\n\n@layer rdg.CheckboxLabel {.c1bn88vv7-0-0-beta-40 {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    margin-inline-end: 1px /* align checkbox in row group cell */\n}\n  }\n\n@layer rdg.CheckboxInput {\n\n.c1qt073l7-0-0-beta-40 {\n    all: unset\n}\n  }\n\n@layer rdg.CheckboxIcon {\n\n.cf71kmq7-0-0-beta-40 {\n    content: '';\n    inline-size: 20px;\n    block-size: 20px;\n    border: 2px solid var(--rdg-border-color);\n    background-color: var(--rdg-background-color)\n}\n\n    .c1qt073l7-0-0-beta-40:checked + .cf71kmq7-0-0-beta-40 {\n      background-color: var(--rdg-checkbox-color);\n      outline: 4px solid var(--rdg-background-color);\n      outline-offset: -6px;\n    }\n\n    .c1qt073l7-0-0-beta-40:focus + .cf71kmq7-0-0-beta-40 {\n      border-color: var(--rdg-checkbox-focus-color);\n    }\n  }\n\n@layer rdg.CheckboxLabel {\n\n.c1lwve4p7-0-0-beta-40 {\n    cursor: default\n}\n\n    .c1lwve4p7-0-0-beta-40 .cf71kmq7-0-0-beta-40 {\n      border-color: var(--rdg-checkbox-disabled-border-color);\n      background-color: var(--rdg-checkbox-disabled-background-color);\n    }\n  }\n\n\n@layer rdg.GroupCellContent {.g1s9ylgp7-0-0-beta-40 {\n    outline: none\n}\n  }\n\n@layer rdg.GroupCellCaret {\n\n.cz54e4y7-0-0-beta-40 {\n    margin-inline-start: 4px;\n    stroke: currentColor;\n    stroke-width: 1.5px;\n    fill: transparent;\n    vertical-align: middle\n}\n\n    .cz54e4y7-0-0-beta-40 > path {\n      transition: d 0.1s;\n    }\n  }\n\n\n@layer rdg.DragHandle {.c1w9bbhr7-0-0-beta-40 {\n    --rdg-drag-handle-size: 8px;\n    z-index: 0;\n    cursor: move;\n    inline-size: var(--rdg-drag-handle-size);\n    block-size: var(--rdg-drag-handle-size);\n    background-color: var(--rdg-selection-color);\n    place-self: end\n}\n\n    .c1w9bbhr7-0-0-beta-40:hover {\n      --rdg-drag-handle-size: 16px;\n      border: 2px solid var(--rdg-selection-color);\n      background-color: var(--rdg-background-color);\n    }\n  }\n\n@layer rdg.DragHandle {\n\n.c1creorc7-0-0-beta-40 {\n    z-index: 1;\n    position: sticky\n}\n  }\n\n\n@layer rdg.EditCell {.cis5rrm7-0-0-beta-40 {\n    padding: 0\n}\n  }\n\n\n@layer rdg.SortableHeaderCell {.h44jtk67-0-0-beta-40 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n  }\n\n@layer rdg.SortableHeaderCellName {\n\n.hcgkhxz7-0-0-beta-40 {\n    flex-grow: 1;\n    overflow: clip;\n    text-overflow: ellipsis;\n    font-weight: 700;\n    font-size: large;\n    \n}\n  }\n\n\n@layer rdg.HeaderCell {.c6l2wv17-0-0-beta-40 {\n    cursor: pointer\n}\n  }\n\n@layer rdg.HeaderCell {\n\n.c1kqdw7y7-0-0-beta-40 {\n    touch-action: none\n}\n  }\n\n@layer rdg.HeaderCell {\n\n.r1y6ywlx7-0-0-beta-40 {\n    cursor: col-resize;\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-end: 0;\n    inset-block-end: 0;\n    inline-size: 10px\n}\n  }\n\n.c1bezg5o7-0-0-beta-40 {\n  opacity: 0.5;\n}\n\n.c1vc96037-0-0-beta-40 {\n  background-color: var(--rdg-header-draggable-background-color);\n}\n\n\n@layer rdg.Row {.r1upfr807-0-0-beta-40 {\n    display: contents;\n    line-height: var(--rdg-row-height);\n\n    background-color: var(--rdg-background-color)\n}\n\n    .r1upfr807-0-0-beta-40:hover {\n      background-color: #8cb3fb //var(--rdg-row-hover-background-color);\n    }\n\n    .r1upfr807-0-0-beta-40[aria-selected='true'] {\n      background-color: var(--rdg-row-selected-background-color);\n    }\n\n      .r1upfr807-0-0-beta-40[aria-selected='true']:hover {\n        background-color: #8cb3fb//var(--rdg-row-selected-hover-background-color);\n      }\n  }\n\n@layer rdg.FocusSink {\n\n.r190mhd37-0-0-beta-40 {\n    outline: 2px solid var(--rdg-selection-color);\n    outline-offset: -2px\n}\n  }\n\n@layer rdg.FocusSink {\n    .r139qu9m7-0-0-beta-40::before {\n      content: '';\n      display: inline-block;\n      height: 100%;\n      position: sticky;\n      inset-inline-start: 0;\n      border-inline-start: 2px solid var(--rdg-selection-color);\n    }\n  }\n\n\n@layer rdg.HeaderRow {.h10tskcx7-0-0-beta-40 {\n    display: contents;\n    line-height: var(--rdg-header-row-height);\n    background-color: #264390;\n    font-weight: bold;\n    color: white;\n}\n\n    .h10tskcx7-0-0-beta-40 > .cj343x07-0-0-beta-40 {\n      /* Should have a higher value than 1 to show up above regular cells and the focus sink */\n      z-index: 2;\n      position: sticky;\n      font-size: large;\n      font-weight: 700;\n    }\n\n    .h10tskcx7-0-0-beta-40 > .csofj7r7-0-0-beta-40 {\n      z-index: 3;\n    }\n  }\n\n\n@layer rdg.Cell {.c6ra8a37-0-0-beta-40 {\n    background-color: #ccccff\n}\n  }\n\n@layer rdg.Cell {\n\n.cq910m07-0-0-beta-40 {\n    background-color: #ccccff\n}\n\n    .cq910m07-0-0-beta-40.c6ra8a37-0-0-beta-40 {\n      background-color: #9999ff;\n    }\n  }\n\n\n@layer rdg.SortIcon {.a3ejtar7-0-0-beta-40 {\n    fill: currentColor;\n    height: 16px;\n    width: 12px;\n}\n\n    .a3ejtar7-0-0-beta-40 > path {\n      transition: d 0.1s;\n    }\n  }\n\n\n@layer rdg {\n    @layer Defaults,\n      FocusSink,\n      CheckboxInput,\n      CheckboxIcon,\n      CheckboxLabel,\n      Cell,\n      HeaderCell,\n      SummaryCell,\n      EditCell,\n      Row,\n      HeaderRow,\n      SummaryRow,\n      GroupedRow,\n      Root;\n\n    @layer Defaults {\n      .rnvodz57-0-0-beta-40 *,\n      .rnvodz57-0-0-beta-40 *::before,\n      .rnvodz57-0-0-beta-40 *::after {\n        box-sizing: inherit;\n      }\n    }\n\n    @layer Root {.rnvodz57-0-0-beta-40 {\n      --rdg-color: #000;   --rdg-border-color: #ddd;   --rdg-summary-border-color: #aaa;   --rdg-background-color: hsl(0deg 0% 100%);   --rdg-header-background-color: hsl(0deg 0% 97.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 90.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 96%);   --rdg-row-selected-background-color: hsl(207deg 76% 92%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 88%);   --rdg-checkbox-color: hsl(207deg 100% 29%);   --rdg-checkbox-focus-color: hsl(207deg 100% 69%);   --rdg-checkbox-disabled-border-color: #ccc;   --rdg-checkbox-disabled-background-color: #ddd;\n      --rdg-selection-color: #66afe9;\n      --rdg-font-size: 14px;\n\n      display: grid;\n\n      color-scheme: var(--rdg-color-scheme, light dark);\n\n      /* https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context */\n      /* We set a stacking context so internal elements don't render on top of external elements. */\n      /* size containment is not used as it could break \"width: min-content\" for example, and the grid would infinitely resize on Chromium browsers */\n      contain: content;\n      content-visibility: auto;\n      block-size: 80vh;\n      border: 1px solid var(--rdg-border-color) !important;\n      box-sizing: border-box;\n      overflow: auto;\n      background-color: var(--rdg-background-color);\n      color: var(--rdg-color);\n      font-size: var(--rdg-font-size)\n\n      /* needed on Firefox to fix scrollbars */\n}\n      .rnvodz57-0-0-beta-40::before {\n        content: '';\n        grid-column: 1/-1;\n        grid-row: 1/-1;\n      }\n\n      .rnvodz57-0-0-beta-40.rdg-dark {\n        --rdg-color-scheme: dark;\n        --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 17.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;\n      }\n\n      .rnvodz57-0-0-beta-40.rdg-light {\n        --rdg-color-scheme: light;\n      }\n\n      @media (prefers-color-scheme: dark) {\n        .rnvodz57-0-0-beta-40:not(.rdg-light) {\n          --rdg-color: #ddd;   --rdg-border-color: #444;   --rdg-summary-border-color: #555;   --rdg-background-color: hsl(0deg 0% 13%);   --rdg-header-background-color: hsl(0deg 0% 10.5%);   --rdg-header-draggable-background-color: hsl(0deg 0% 17.5%);   --rdg-row-hover-background-color: hsl(0deg 0% 9%);   --rdg-row-selected-background-color: hsl(207deg 76% 42%);   --rdg-row-selected-hover-background-color: hsl(207deg 76% 38%);   --rdg-checkbox-color: hsl(207deg 100% 79%);   --rdg-checkbox-focus-color: hsl(207deg 100% 89%);   --rdg-checkbox-disabled-border-color: #000;   --rdg-checkbox-disabled-background-color: #333;\n        }\n      }\n    }\n  }\n\n@layer rdg.Root {\n\n.vlqv91k7-0-0-beta-40 {\n    user-select: none\n}\n\n    .vlqv91k7-0-0-beta-40 .r1upfr807-0-0-beta-40 {\n      cursor: move;\n    }\n  }\n\n@layer rdg.FocusSink {\n\n.f1lsfrzw7-0-0-beta-40 {\n    grid-column: 1/-1;\n    pointer-events: none;\n    /* Should have a higher value than 1 to show up above regular frozen cells */\n    z-index: 1\n}\n  }\n\n@layer rdg.FocusSink {\n\n.f1cte0lg7-0-0-beta-40 {\n    /* Should have a higher value than 3 to show up above header and summary rows */\n    z-index: 3\n}\n  }\n\n\n@layer rdg.SummaryCell {.s8wc6fl7-0-0-beta-40 {\n    inset-block-start: var(--rdg-summary-row-top);\n    inset-block-end: var(--rdg-summary-row-bottom)\n}\n  }\n\n\n@layer rdg.SummaryRow {.skuhp557-0-0-beta-40 {\n    line-height: var(--rdg-summary-row-height)\n}\n\n    .skuhp557-0-0-beta-40 > .cj343x07-0-0-beta-40 {\n      position: sticky;\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .tf8l5ub7-0-0-beta-40 > .cj343x07-0-0-beta-40 {\n      z-index: 2;\n    }\n\n    .tf8l5ub7-0-0-beta-40 > .csofj7r7-0-0-beta-40 {\n      z-index: 3;\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .tb9ughf7-0-0-beta-40 > .cj343x07-0-0-beta-40 {\n      border-block-end: 2px solid var(--rdg-summary-border-color);\n    }\n  }\n\n@layer rdg.SummaryRow {\n    .b1yssfnt7-0-0-beta-40 > .cj343x07-0-0-beta-40 {\n      border-block-start: 2px solid var(--rdg-summary-border-color);\n    }\n  }\n\n\n@layer rdg.GroupedRow {\n    .g1yxluv37-0-0-beta-40:not([aria-selected='true']) {\n      background-color: var(--rdg-header-background-color);\n    }\n\n    .g1yxluv37-0-0-beta-40 > .cj343x07-0-0-beta-40:not(:last-child):not(.ch2wcw87-0-0-beta-40) {\n      border-inline-end: none;\n    }\n  }\n\n\n@layer rdg.TextEditor {.t7vyx3i7-0-0-beta-40 {\n    appearance: none;\n\n    box-sizing: border-box;\n    inline-size: 100%;\n    block-size: 100%;\n    padding-block: 0;\n    padding-inline: 6px;\n    border: 2px solid #ccc;\n    vertical-align: top;\n    color: var(--rdg-color);\n    background-color: var(--rdg-background-color);\n\n    font-family: inherit;\n    font-size: var(--rdg-font-size)\n}\n\n    .t7vyx3i7-0-0-beta-40:focus {\n      border-color: var(--rdg-selection-color);\n      outline: none;\n    }\n\n    .t7vyx3i7-0-0-beta-40::placeholder {\n      color: #999;\n      opacity: 1;\n    }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
